

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DetailsView } from "./DetailsView";
import { GalleryView } from "./GalleryView";
import { MobileContentProps } from "@/app/types/ui.types";


export const MobileContent: React.FC<MobileContentProps> = ({
  activeTab,
  product,
  cartItemToEdit,
  availabilityMap,
  selectedCustomizations,
  handleCustomizationSelect,
  hasAccessoriesCustomization,
  premiumPackageData,
  isPremiumEnabled,
  setIsPremiumEnabled,
  handleConfirm,
  handleBuyNow,
  isCartLoading,
  priceBreakdown,
  isWholesaleUser,
  finalDimensions,
  quantity,
  onQuantityChange,
  minQuantity,
  isSelectedColorOutOfStock,
  imageList,
  currentImageIndex,
  setCurrentImageIndex,
  availableColors,
}) => {
  return (
    <div className="flex-grow overflow-y-auto">
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, x: activeTab === "details" ? -20 : 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: activeTab === "details" ? 20 : -20 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
          className="h-full"
        >
          {activeTab === "details" && (
            <DetailsView
              product={product}
              cartItemToEdit={cartItemToEdit}
              availabilityMap={availabilityMap}
              selectedCustomizations={selectedCustomizations}
              handleCustomizationSelect={handleCustomizationSelect}
              hasAccessoriesCustomization={hasAccessoriesCustomization}
              premiumPackageData={premiumPackageData}
              isPremiumEnabled={isPremiumEnabled}
              setIsPremiumEnabled={setIsPremiumEnabled}
              handleConfirm={handleConfirm}
              handleBuyNow={handleBuyNow}
              isCartLoading={isCartLoading}
              priceBreakdown={priceBreakdown}
              isWholesaleUser={isWholesaleUser}
              finalDimensions={finalDimensions}
              quantity={quantity}
              onQuantityChange={onQuantityChange}
              minQuantity={minQuantity}
              isSelectedColorOutOfStock={isSelectedColorOutOfStock}
            />
          )}
          {activeTab === "gallery" && (
            <GalleryView
              product={product}
              imageList={imageList}
              currentImageIndex={currentImageIndex}
              setCurrentImageIndex={setCurrentImageIndex}
              selectedColorName={selectedCustomizations["Color"]}
              handleColorSelect={(name) =>
                handleCustomizationSelect("Color", name)
              }
              selectedCustomizations={selectedCustomizations}
              availableColors={availableColors}
              quantity={quantity}
              isWholeSaleUser={isWholesaleUser}
            />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};